import Container from "../core/Container"
import Heading from "../core/Heading"
import Image from "../core/Image"
import Paragraph from "../core/Paragraph"
import Button from "../core/Button"
import { useNavigate } from "react-router-dom"
import { useState, useEffect, useRef } from "react"


export default function LandingBanner(){
    
    const navigate = useNavigate();
    const [gradientAngle, setGradientAngle] = useState(0);
    const canvasRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setGradientAngle(prev => (prev + 1) % 360);
        }, 50); // 50ms update

        return () => clearInterval(interval);
    }, []);

    // Particle system
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        let animationFrameId;

        // Set canvas size
        const resizeCanvas = () => {
            canvas.width = canvas.offsetWidth;
            canvas.height = canvas.offsetHeight;
        };
        resizeCanvas();
        window.addEventListener('resize', resizeCanvas);

        // Particle class
        class Particle {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.size = Math.random() * 3 + 1;
                this.speedX = (Math.random() - 0.5) * 0.5;
                this.speedY = (Math.random() - 0.5) * 0.5;
                this.opacity = Math.random() * 0.5 + 0.2;
            }

            update() {
                this.x += this.speedX;
                this.y += this.speedY;

                // Bounce off edges
                if (this.x < 0 || this.x > canvas.width) this.speedX *= -1;
                if (this.y < 0 || this.y > canvas.height) this.speedY *= -1;

                // Keep particles in bounds
                this.x = Math.max(0, Math.min(canvas.width, this.x));
                this.y = Math.max(0, Math.min(canvas.height, this.y));
            }

            draw() {
                ctx.fillStyle = `rgba(255, 255, 255, ${this.opacity})`;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fill();
            }
        }

        // Create particles
        const particles = [];
        const particleCount = 30;
        for (let i = 0; i < particleCount; i++) {
            particles.push(new Particle());
        }

        // Animation loop
        const animate = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Draw connections between nearby particles
            particles.forEach((particle, i) => {
                particle.update();
                particle.draw();

                // Connect nearby particles
                particles.slice(i + 1).forEach(otherParticle => {
                    const dx = particle.x - otherParticle.x;
                    const dy = particle.y - otherParticle.y;
                    const distance = Math.sqrt(dx * dx + dy * dy);

                    if (distance < 120) {
                        ctx.strokeStyle = `rgba(255, 255, 255, ${0.1 * (1 - distance / 120)})`;
                        ctx.lineWidth = 0.5;
                        ctx.beginPath();
                        ctx.moveTo(particle.x, particle.y);
                        ctx.lineTo(otherParticle.x, otherParticle.y);
                        ctx.stroke();
                    }
                });
            });

            animationFrameId = requestAnimationFrame(animate);
        };

        animate();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    const handleKurzyClick = () => {
        navigate("/kurzy")
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Init colors
    const mainColor = '#5170ff';
    const secondColor = '#ff66c4';
    const gradientStyle = {
        background: `linear-gradient(${gradientAngle}deg, ${mainColor}, ${secondColor})`,
        transition: 'background 0.3s ease'
    };

    return(
        <Container shadow={true} className="w-full relative overflow-hidden" style={gradientStyle}>
            {/* Particles canvas */}
            <canvas
                ref={canvasRef}
                className="absolute inset-0 w-full h-full pointer-events-none"
                style={{ zIndex: 1 }}
            />
            <Container bgColor="transparent" className="max-w-7xl mx-auto grid lg:grid-cols-[30%_70%] sm:flex-cols items-center py-12 relative" style={{ zIndex: 2 }}> 
                {/*Obrázek*/}
                <Container bgColor="transparent" className="flex items-center justify-center">
                    <Image
                        src="./img/digiboy_thumb_up.png"
                        width={380}

                    />

                {/*Text*/}
                </Container>
                <Container bgColor="transparent" className="flex flex-col items-start justify-center px-8 space-y-4 text-white">
                    <Heading variant="h0" color="white">Učte se bez stresu, digitálně a efektivně</Heading>
                    <Container bgColor="transparent" className="text-lg">
                        <Paragraph variant="lead">Vaše cesta k bezstresovému vzdělávání začíná zde. Objevte moderní způsob přípravy a výuky pomocí digitálních nástrojů, které vám ušetří čas a energii.</Paragraph>
                    </Container>
                    <Container bgColor="transparent" className="w-full flex justify-center lg:justify-start">
                        <Button
                            variant="primary"
                            size="xl"
                            onClick={handleKurzyClick}
                        >
                            Naše kurzy!
                        </Button>
                    </Container>
                </Container>
            </Container>
        </Container>

    )
}
